/**
 * Lakehouse Help Content
 * 
 * Feature: 136-dashboard-alignment (T048)
 * Pages: /lakehouses, /lakehouses/catalog
 * Constitution: v1.12.0
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const lakehouseHelp: PageHelpContent = {
  pageTitle: 'Lakehouses',
  purpose: 'Manage and monitor Fabric Lakehouses across all capacities, including table/file counts and optimization status.',
  sections: [
    {
      title: 'Overview',
      paragraphs: [
        'Lakehouses are the primary data storage construct in Microsoft Fabric, built on Delta Lake format. This page shows all discovered lakehouses with their current state, table counts, and backup status.',
      ],
    },
    {
      title: 'Key Concepts',
      concepts: [
        { term: 'Lakehouse', definition: 'A Fabric item that combines data lake storage with analytical query capabilities via Delta tables.' },
        { term: 'Table Count', definition: 'Number of Delta tables discovered in the lakehouse. Monitored for drift detection.' },
        { term: 'File Count', definition: 'Total files in the lakehouse storage, including tables, shortcuts, and unstructured data.' },
        { term: 'Optimization Status', definition: 'Whether the lakehouse tables have been recently optimized (compacted, vacuumed) for query performance.' },
      ],
    },
    {
      title: 'Catalog View',
      paragraphs: [
        'The catalog view provides a browsable index of all lakehouses organized by workspace, capacity type, or client. Use it to discover lakehouses and drill into their details.',
      ],
    },
    {
      title: 'How To',
      steps: [
        { step: 1, instruction: 'Browse the Lakehouses list to see all discovered lakehouses with their table counts, file counts, and workspace.' },
        { step: 2, instruction: 'Check backup status for a lakehouse by reviewing the status badge in the list or clicking through to its detail page.' },
        { step: 3, instruction: 'Switch to the Catalog view to browse lakehouses organized by workspace, capacity, or client for easier discovery.' },
        { step: 4, instruction: 'Click a lakehouse row to view detailed information including Delta table inventory, optimization status, and storage metrics.' },
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Workspaces', href: '/workspaces' },
        { label: 'Warehouses', href: '/warehouses' },
        { label: 'Backup Runs', href: '/backup' },
      ],
    },
  ],
};

export default lakehouseHelp;
